var alignmentStyle = {"alignLeft":"Lk7XI","textWrapNowrap":"NsOco","alignRight":"hcMxy","alignCenter":"AueE6","sizeFullWidth":"J9SHl","renderedInTable":"_0J0zA","sizeOriginal":"hd7Cb","sizeContent":"G-fIa","sizeSmall":"_8-o-N","sizeSmallCenter":"Yfm7G","flex":"-wCVu","LEFT":"IhQiY","CENTER":"V2yon","RIGHT":"VG5DC","AUTO":"bazzW","JUSTIFY":"nBal9"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-68da41fb.js.map
